module.exports = __webpack_public_path__ + "static/media/nil.ae60db86.png";